<template>
	<div class="offline-footer">
		<div class="offline-footer-nav">
			<div class="offline-footer-nav-category" v-for="(data, index) of footerLinks" :key="index">
				<div class="offline-footer-nav-category-title">{{ data.category }}</div>
				<div class="offline-footer-nav-category-link">
					<template v-for="(link, index) in data.links">
						<a v-if="link.external"
							:href="link.route"
							:key="index+'-external'"
							target="_blank">
							{{ link.title }}
						</a>
						<router-link v-else
							:key="index+'-internal'"
							:to="{name: link.route}">
							{{ link.title }}
						</router-link>
					</template>
					<div class="offline-footer-nav-category-reseaux" v-if="index === 0">
						<a href="https://www.facebook.com/coolocblog/" target="_blank"><img src="/static/images/icons/fb.svg" style="width: 23px; height: 23px" /></a>
						<a href="https://www.instagram.com/cooloc/" target="_blank"><img src="/static/images/icons/insta.svg" style="width: 23px; height: 23px" /></a>
					</div>
				</div>
			</div>
		</div>
		<div class="offline-footer-sponsor">
			<div class="offline-footer-sponsor-image">
				<a href="https://frenchtech-grandparis.com/" target="_blank"><img src="/static/images/logos/grand_paris-logo.png" style="height: 80px; padding-left:30px"/></a>
			</div>
			<div class="offline-footer-sponsor-image">
				<a href="https://impulse-partners.com/fr/" target="_blank"><img src="/static/images/logos/logo_Impulse_08.01.2018_1000x138.jpg" style="width: 260px"/></a>
			</div>
			<div class="offline-footer-sponsor-image">
				<a href="https://www.bpifrance.fr/" target="_blank"><img src="/static/images/logos/bpifrance-logo.jpg" style="width: 260px"/></a>
			</div>
			<div class="offline-footer-sponsor-image" style="background-color: #fff">
				<a href="https://francedigitale.org/" target="_blank" ><img src="/static/images/logos/france-digitale-revu.png"/></a>
			</div>
		</div>
		<div class="offline-footer-orias">COOLOC est enregistré à l’ORIAS (Organisme pour le registre unique des intermédiaires en assurance) comme courtier en assurance sous le numéro 24005996.</div>
	</div>
</template>

<script>
export default {
  props: {
    footerLinks: {
      default: () => [
        {
          id: 1,
          category: 'cooloc',
          links: [
            { title: 'Charte de bonne conduite', route: process.env.VUE_APP_COOLOC_BASE_URL + '/fr/charte-de-bonne-conduite', external: true },
            { title: 'Conseils utiles', route: process.env.VUE_APP_COOLOC_BASE_URL + '/fr/blog', external: true },
          ],
        },
        {
          id: 2,
          category: 'à propos',
          links: [
            { title: 'Qui sommes-nous ?', route: process.env.VUE_APP_COOLOC_BASE_URL + '/fr/qui-sommes-nous', external: true },
            { title: 'CGU', route: process.env.VUE_APP_COOLOC_BASE_URL + '/fr/cgu', external: true },
            { title: 'Mentions légales', route: process.env.VUE_APP_COOLOC_BASE_URL + '/fr/mentions-legales', external: true },
            // { title: 'Presse', route: '' },
          ],
        },
        {
          id: 3,
          category: 'outils',
          links: [
            { title: 'Contactez-nous', route: process.env.VUE_APP_COOLOC_BASE_URL + '/fr/proprietaire#contact-us', external: true },
            // { title: 'Plan du site', route: '' },
            { title: 'FAQ', route: process.env.VUE_APP_COOLOC_BASE_URL + '/fr/faq', external: true },
          ],
        },
        {
          id: 4,
          category: 'services',
          links: [
            { title: 'Connexion', route: 'SignIn' },
          ],
        },
      ],
    },
  },
}
</script>

<style lang="scss">
	.offline-footer {
    background: white;
    border-top: solid 1px rgb(236, 236, 234);
    padding: 40px 0px;
    width: 100%;
		height: 420px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		margin: 80px 0px 0px 0px;
		&-nav {
			display: flex;
      column-gap: 40px;
			width: max-content;
			&-category {
				display: flex;
        width: max-content;
        flex-grow: 0;
				flex-direction: column;
        height: max-content;
        row-gap: 16px;
				flex: 1;
				&-title {
					font-size: 14px;
					line-height: 17px;
					color: $red;
					text-transform: uppercase;
				}
				&-link {
					display: flex;
					flex-direction: column;
					height: 104px;
					margin-top: 30px;
          min-width: 150px;
					a {
						margin-bottom: 10px;
						font-size: 15px;
						line-height: 18px;
						color: $gray1;
					}
				}
				&-reseaux {
					margin-top: 20px;
					img {
						width: 23px;
						height: 23px;
					}
					img:first-child {
						margin-right: 20px;
					}
				}
			}
		}
		&-sponsor {
			width: auto;
			border-top: 1px solid $tanlight;
			padding-top: 20px;
			display: flex;
			justify-content: space-evenly;
			&-image {
				display: flex;
				align-items: center;
				margin-right: 10px;
				img:nth-child(2) {
					margin-left: 10px;
				}
			}
		}
		@include tablet {
			$mwidth: 414px;
			width: 100% !important;
			height: auto;
			padding: 0 0 10px 0 !important;
			margin-bottom: 75px; // compensate nav footer links
			&-nav {
				flex-shrink: 0;
				height: 100px !important;
				flex-direction: column;
				justify-content: center;
				&-category {
					height: 0 !important;
					width: 100%;
					flex: 0;

					&-title {
						display: none !important;
					}
					&-link {
						height: 0 !important;
						margin-top: 0 !important;
						> a {
							display: none !important;
						}
					}
					&-reseaux {
						display: flex;
						width: 100% !important;
						margin-top: 0 !important;
						justify-content: center;
						> a {
							width: 24px;
							&:first-child {
								margin-right: 70px !important;
							}
						}
					}
				}
			}
			&-sponsor {
				flex-wrap: wrap;
				&-image {
					padding: 10px 0;
					display: block;
					width: 100%;
					text-align: center;
					img {
						object-fit: contain;
					}
				}
			}
		}

		&-orias {
			color: $gray7;
			font-style: italic;
			margin-top: 20px;
			font-size: 14px;
			text-align: center;
		}
	}
</style>
